import { render, staticRenderFns } from "./productDetailInstock.vue?vue&type=template&id=980235ca&scoped=true"
import script from "./productDetailInstock.vue?vue&type=script&lang=js"
export * from "./productDetailInstock.vue?vue&type=script&lang=js"
import style0 from "./productDetailInstock.vue?vue&type=style&index=0&id=980235ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980235ca",
  null
  
)

export default component.exports